module.exports = __webpack_public_path__ + "static/media/SupplierLogo.c9272f8a.png";